import { createStore, Event } from 'effector';

import { applyReducers } from '@m/effector-utils';
import { logout } from 'apps/customer/state/user';

import { setFromSms, setPromoShortCode, setTnDiscountSheetDismissedOnVisit } from './actions';

type PromoState = {
  fromSms: boolean;
  savedShortCode: string;
  tnDiscountSheetDismissedForVisitId: number | null;
};

const initialState: PromoState = {
  savedShortCode: '',
  fromSms: false,
  tnDiscountSheetDismissedForVisitId: null,
};

const store = createStore(initialState);

type Reducers = {
  setFromSms: {
    action: Event<boolean>;
    reducer: (state: PromoState, payload: boolean) => PromoState;
  };
  setPromoShortCode: {
    action: Event<string>;
    reducer: (state: PromoState, payload: string) => PromoState;
  };
  setTnDiscountSheetDismissedOnVisit: {
    action: Event<number | null>;
    reducer: (state: PromoState, payload: number | null) => PromoState;
  };
};

export const reducers: Reducers = {
  setPromoShortCode: {
    action: setPromoShortCode,
    reducer: (state, payload) => ({
      ...state,
      savedShortCode: payload,
    }),
  },
  setFromSms: {
    action: setFromSms,
    reducer: (state, payload) => ({
      ...state,
      fromSms: payload,
    }),
  },
  setTnDiscountSheetDismissedOnVisit: {
    action: setTnDiscountSheetDismissedOnVisit,
    reducer: (state, payload) => ({
      ...state,
      tnDiscountSheetDismissedForVisitId: payload,
    }),
  },
};

store.reset(logout.done);

export default applyReducers({ store, reducers });
